import { Card, CardContent, Stack, Unstable_Grid2 as Grid } from '@mui/material';

import { Divider, InfoField } from '@occc-app/design-system';
import { MessagingCampaignDetailsFragment } from '@occc/graphql';

type MessageDetailsProps = {
  channelsConfig: MessagingCampaignDetailsFragment['channelsConfig'];
};

export const MessageDetails = ({ channelsConfig }: MessageDetailsProps) => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={3}>
          <Grid container xs={12}>
            <Grid xs={12}>
              <InfoField
                label='SMS Body'
                value={channelsConfig?.smsConfig?.body}
                sx={{ wordBreak: 'break-all' }}
                mb={0}
              />
            </Grid>
          </Grid>

          <Divider />

          <Grid
            container
            columnSpacing={3}
            xs={12}
            sx={{
              '& > :first-of-type': { pl: 0 },
              '& > :last-of-type': { pr: 0 },
            }}
          >
            <Grid xs={12} sm={3}>
              <InfoField
                label='Push Title'
                value={channelsConfig?.pushNotificationConfig?.template?.notification?.title}
                sx={{ wordBreak: 'break-all' }}
                mb={0}
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <InfoField
                label='Push Body'
                value={channelsConfig?.pushNotificationConfig?.template?.notification?.body}
                sx={{ wordBreak: 'break-all' }}
                mb={0}
              />
            </Grid>
            <Grid xs={12} sm={3}>
              <InfoField
                label='Deeplink'
                value={channelsConfig?.pushNotificationConfig?.template?.data?.url}
                sx={{ wordBreak: 'break-all' }}
                mb={0}
              />
            </Grid>
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  );
};
